import { useContext } from 'react';
import FormikSelectInput from '../../../components/Input/FormikSelectInput';
import { MojeIdContext } from '../../../context/MojeIdContext';

interface SelectIdCardTypeProps {
    countryCode: string;
    name: string;
    label: string;
    disabled?: boolean;
    required?: boolean;
}

export const SelectIdCardType = ({ countryCode, ...props }: SelectIdCardTypeProps) => {
    const { initData } = useContext(MojeIdContext);

    const { IdCardConfigurationCitizenshipAssocs, IdCardConfigurations } = initData || {};

    const assocs = (IdCardConfigurationCitizenshipAssocs || []).filter(
        (a: any) => a.CitizenshipCountryCode === countryCode
    );
    const options = (IdCardConfigurations || []).filter((a: any) =>
        assocs.find((ass: any) => ass.IdCardConfigurationCode === a.Code)
    );

    return (
        <FormikSelectInput
            isCenter
            options={options.map((idCard: any) => ({
                value: idCard.IdCardKindCode,
                label: idCard.DisplayNameTranslated,
            }))}
            {...props}
        />
    );
};
